<script>
import FormModalMixin from '../../../../../share/modal/FormModalMixin'
import FormModal from '../form/BankEdit'
import api from '../../../../../../api'

export default {
  components: {
    FormModal
  },
  mixins: [
    FormModalMixin
  ],
  data () {
    return {
      title: 'Edycja danych banku',
      okText: 'Zmień'
    }
  },
  methods: {
    submitForm () {
      api.request('core', 'put', `/bank/${this.$route.params.id}`, this.createDataToSend())
        .then(() => {
          this.toggleLoading()

          this.$emit('success', this.model)
          this.$emit('close')
          this.$notify({
            type: 'success',
            text: 'Zaktualizowano dane banku'
          })
        })
        .catch((error) => {
          this.toggleLoading()
          this.errorNotify(error)
        })
    },
    createDataToSend () {
      return {
        label: this.model.label,
        voivodeship: this.model.voivodeship,
        city: this.model.city,
        postcode: this.model.postcode,
        street: this.model.street,
        email: this.model.email,
        phone: this.model.phone
      }
    }
  }
}
</script>
